import React, { Component } from 'react';
import  { connect } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { reorderTypeIds, removeTypeId } from '../../redux/actions/typeId';
import Input from '../customInputs';
import { removeRegTypeId } from "../../redux/actions/regTypeId";
import { INPUT_TYPES } from '../../config/constants';
import { ResultPageWrapper } from '../resultPageWrapper';


const getItemStyle = (isDragging, draggableStyle) => ({
    padding: '5px',
    margin: '5px',
    background: isDragging ? '#9dc7ef' : '#ffffff',
    ...draggableStyle,
  });

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

class Preview extends Component {

    onDragEnd = (result) => {
        if (!result.destination) {
          return;
        }

        const items = reorder(
          this.props.typeIds[this.props.activeBuilderType],
          result.source.index,
          result.destination.index
        );

        this.props.reorderTypeIds({
            activeBuilderType: this.props.activeBuilderType,
            typeIds: items
        })
    };

    removeItem = (item) => {
        if (item.type === INPUT_TYPES.REGISTRATION) {
            this.props.removeRegTypeId({ key: item.id });
        }

        this.props.removeTypeId({
            activeBuilderType: this.props.activeBuilderType,
            itemId: item.id
        });
    };

    render() {
        const { typeIds, activeBuilderType, colors, bgImage } = this.props;
        return (
            <ResultPageWrapper
                backgroundImage={bgImage}
                targetBuilderType={activeBuilderType}
                colors={colors}
            >
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided) => (
                            <div style={{ background: '#f2f2f2' }} ref={provided.innerRef}>
                                {
                                    typeIds[activeBuilderType].map((item, index) => (
                                        <Draggable
                                            key={item.id}
                                            draggableId={String(item.id)}
                                            index={index}
                                        >
                                            {
                                                (provided, snapshot) => (
                                                    <div
                                                        id={item.id}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}
                                                    >
                                                        <div className="btns-wrapper">
                                                            <button
                                                                onClick={() => this.removeItem(item) }
                                                                className="btn btn-danger remove-btn"
                                                            >Remove
                                                            </button>
                                                        </div>

                                                        <Input
                                                            color={colors[activeBuilderType].elementColor}
                                                            textColor={colors[activeBuilderType].textColor}
                                                            initialValues={item}
                                                        />

                                                    </div>
                                                )}
                                        </Draggable>
                                    ))}
                                { provided.placeholder }
                            </div>
                        )}

                    </Droppable>
                </DragDropContext>
            </ResultPageWrapper>

        );
    }
}

export default connect(
    state => ({
        bgImage: state.bgImage,
        typeIds: state.typeId,
        colors: state.colors,
        activeBuilderType: state.activeBuilderType,
    }),
    {
        reorderTypeIds,
        removeTypeId,
        removeRegTypeId
    }
  )(Preview);
